import React from "react";
import "./Signup.scss";
import { useNavigate } from "react-router-dom";
import Stepper from "../../components/Stepper/Stepper";
import loginImage from "../../assets/Images/LoginImage.png"

const Signup = () => {
  const navigate = useNavigate();
  return (
    <div className="Signup">
      <div className="Signup_container">
        <div className="Signup_section">
          <div className="Signup_section_left">
            <div className="Signup_section_left_img">
            <img src={loginImage} alt="Image" />
            </div>
          </div>
          <div className="Signup_section_right">
            <div className="Signup_section_right_box">
              <div className="Signup_section_right_box_header">
                <Stepper />
                <div className="line"></div>
                <div className="Signup_section_right_box_header_content_text">
                  <p>
                    Have some problems? Please <span onClick={() => {
                      navigate("/logincontactsupport");
                    }}>contact support.</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signup;
